import utils from '@/mixins/utils.js'
import { getQuantidadeAcoes } from './functions.js'

function dadosExpandidosComoJson(item) {
  const d = item.dados
  if (d == null || d === '') return ''
  if (typeof d === 'string') return d
  try {
    return JSON.stringify(d)
  } catch {
    return ''
  }
}

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Boolean} exibirEspecificas Indica se o filtro de específicas está ativo.
 * @returns {Object}
 */
export function getDataFields(mes = null, exibirEspecificas = false) {
  const colunaQuantidade = exibirEspecificas ? 'Especificas' : 'Compartilhadas'

  return {
    Nome: {
      callback: (item) => item.no_cidadao?.trim() || '-',
    },

    'Data de nascimento': {
      callback: (item) =>
        item.dt_nascimento ? utils.methods.formatDate(item.dt_nascimento) : '-',
    },

    Mãe: {
      callback: (item) => item.no_mae?.trim() || '-',
    },

    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeAcoes(item, mes, exibirEspecificas)
      },
    },

    Dados: {
      callback: (item) => dadosExpandidosComoJson(item),
    },
  }
}
export const infoHtml = ``
